// entrada: String, saida: String
export const parseTimeToInt = ({ entrada, saida }) => {
  return {
    entrada:
      entrada.length === 0 ? undefined : parseInt(entrada.replace(/\D/g, '')),
    saida: saida.length === 0 ? undefined : parseInt(saida.replace(/\D/g, ''))
  }
}

export const formatToDatabaseDate = data => {
  return (
    data.getFullYear() +
    '-' +
    (data.getMonth() + 1).toString().padStart(2, '0') +
    '-' +
    data
      .getDate()
      .toString()
      .padStart(2, '0')
  )
}

export const padTo2Digits = num => {
  return num.toString().padStart(2, '0')
}

export const formatTo2DigitsDate = date => {
  return `${padTo2Digits(date.getDate())}/${padTo2Digits(
    date.getMonth() + 1
  )}/${date.getFullYear()}`
}



// WEBPACK FOOTER //
// ./src/utils/times.js